/**
 * Mock notification data and type definitions.
 */

export const NOTIFICATION_TYPES = {
  TOKEN_MESSAGE: 'token_message',
  WENT_LIVE: 'went_live',
  MENTION: 'mention',
  FOLLOW: 'follow',
  DIRECT_MESSAGE: 'direct_message',
};

export const MOCK_NOTIFICATIONS = [
  {
    id: 1,
    type: NOTIFICATION_TYPES.TOKEN_MESSAGE,
    user: { username: 'DogDog', avatar: null },
    amount: 5000,
    timestamp: '5 hours ago',
    read: false,
  },
  {
    id: 2,
    type: NOTIFICATION_TYPES.WENT_LIVE,
    user: { username: 'Bob Ross', avatar: null },
    timestamp: '7 hours ago',
    read: false,
  },
  {
    id: 3,
    type: NOTIFICATION_TYPES.TOKEN_MESSAGE,
    user: { username: 'snoopy', avatar: null },
    amount: 5000,
    timestamp: 'A day ago',
    read: true,
  },
  {
    id: 4,
    type: NOTIFICATION_TYPES.WENT_LIVE,
    user: { username: 'Derek', avatar: null },
    timestamp: 'A day ago',
    read: true,
  },
  {
    id: 5,
    type: NOTIFICATION_TYPES.TOKEN_MESSAGE,
    user: { username: 'MsMarble', avatar: null },
    amount: 5000,
    timestamp: '3 days ago',
    read: true,
  },
  {
    id: 6,
    type: NOTIFICATION_TYPES.WENT_LIVE,
    user: { username: 'StreamQueen', avatar: null },
    timestamp: '3 days ago',
    read: true,
  },
  {
    id: 7,
    type: NOTIFICATION_TYPES.FOLLOW,
    user: { username: 'NewFan42', avatar: null },
    timestamp: '4 days ago',
    read: true,
  },
  {
    id: 8,
    type: NOTIFICATION_TYPES.TOKEN_MESSAGE,
    user: { username: 'BigSpender', avatar: null },
    amount: 10000,
    timestamp: '5 days ago',
    read: true,
  },
];
